import React from 'react';

import { ErrorCard } from '@eika/card';

import { useCard } from '@/react-query/hooks/query/use-card';
import useCardRules from '@/react-query/hooks/query/use-card-rules';
import { useCardSpendingLimits } from '@/react-query/hooks/query/use-spending-limits';

import { useIsHighFraudRisk } from '@hooks/use-is-high-risk';
import useText from '@hooks/use-text';

import { CardRulesSetting } from './CardRulesSetting';
import { EcommerceSetting } from './EcommerceSetting';
import { SpendingLimitsEcommerceSettings } from './SpendingLimitsEcommerceSettings';
import { SpendingLimitsSettings } from './SpendingLimitsSettings';
import InfoModal from './modals/InfoModal';

const Settings = () => {
    const { data: card } = useCard();
    const { isError: cardRulesError } = useCardRules();
    const { isError: spendingLimitError } = useCardSpendingLimits();
    const { regionBlockFetchError, spendingLimitFetchError } = useText();
    const isHighFraudRisk = useIsHighFraudRisk();

    const error = cardRulesError && spendingLimitError;

    if (error) {
        return <ErrorCard title={cardRulesError ? regionBlockFetchError : spendingLimitFetchError} />;
    }

    return (
        <>
            <div className="card-control__settings">
                {card && (
                    <>
                        {card.allowedOperations.getSpendingLimit && <SpendingLimitsSettings />}
                        {!isHighFraudRisk && <EcommerceSetting />}
                        {card.allowedOperations.getSpendingLimit && !isHighFraudRisk && (
                            <SpendingLimitsEcommerceSettings />
                        )}
                        <CardRulesSetting />
                    </>
                )}
            </div>
            <InfoModal />
        </>
    );
};

export default Settings;
